(() => {
  const PRODUCT_TITLE = 'Fällkeil Forst Set 5-teilig';
  const BASE_LABEL = '5-teiliges Set';
  const DOUBLE_LABEL = '2x 5-teiliges Set';

  function isTargetProduct() {
    const h1 = document.querySelector('h1, .product-title, [class*="title"]');
    return h1 && h1.textContent && h1.textContent.includes(PRODUCT_TITLE);
  }

  function getSelectedLabel() {
    const checked = document.querySelector('input[type="radio"]:checked');
    if (checked) {
      const label = checked.id ? document.querySelector(`label[for="${CSS.escape(checked.id)}"]`) : null;
      const text = (label || checked.closest('label'))?.textContent?.trim();
      if (text) return text;
    }

    const selected = Array.from(document.querySelectorAll('[aria-pressed="true"], [aria-checked="true"], .is-selected, .selected'))
      .find((el) => (el.textContent || '').includes(BASE_LABEL) || (el.textContent || '').includes(DOUBLE_LABEL));

    if (selected) return selected.textContent.trim();

    return document.body.innerText.includes(DOUBLE_LABEL) && window.location.href.includes('53148673638730') ? DOUBLE_LABEL : BASE_LABEL;
  }

  function setHidden(el, hidden) {
    if (!el) return;
    el.style.display = hidden ? 'none' : '';
  }

  function ensureDoubleCompare(priceList) {
    const salePrice = priceList.querySelector('sale-price');
    if (!salePrice) return;

    let discount = salePrice.querySelector('.ji-discount');
    if (!discount) {
      discount = document.createElement('span');
      discount.className = 'ji-discount absina-fallkeil-added';
      discount.style.cssText = 'color:#1f9d4e;font-weight:600;margin-right:6px;';
      discount.textContent = '-5%';
      salePrice.insertBefore(discount, salePrice.firstChild);
    }

    let compare = priceList.querySelector('compare-at-price.ji-compare');
    if (!compare) {
      compare = document.createElement('compare-at-price');
      compare.className = 'ji-compare text-sm absina-fallkeil-added';
      compare.style.cssText = 'display:block;flex-basis:100%;width:100%;order:2;margin-top:-6px;text-align:left;line-height:1.1;';
      compare.innerHTML = '<span class="sr-only">Regulärer Preis</span><span class="ji-compare-prefix" style="color:#6b7280;font-weight:400;margin-right:4px;">Statt:</span><span class="ji-compare-value" style="text-decoration:line-through;color:rgb(var(--on-sale-text));">39,98€</span>';
      salePrice.insertAdjacentElement('afterend', compare);
    }

    setHidden(discount, false);
    setHidden(compare, false);
  }

  function applyFix() {
    if (!isTargetProduct()) return;

    const label = getSelectedLabel();
    const isDouble = label.includes(DOUBLE_LABEL) || window.location.href.includes('53148673638730');
    const isBase = !isDouble;

    document.querySelectorAll('price-list').forEach((priceList) => {
      const discount = priceList.querySelector('.ji-discount');
      const compare = priceList.querySelector('compare-at-price.ji-compare, compare-at-price');
      const unitPill = priceList.querySelector('.ji-unit-pill');

      if (isBase) {
        setHidden(discount, true);
        setHidden(compare, true);
        setHidden(unitPill, true);
      } else {
        ensureDoubleCompare(priceList);
        setHidden(unitPill, false);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', applyFix);
  document.addEventListener('change', () => setTimeout(applyFix, 80));
  document.addEventListener('click', () => setTimeout(applyFix, 120));
  document.addEventListener('variant:change', () => setTimeout(applyFix, 80));
  new MutationObserver(() => applyFix()).observe(document.documentElement, { childList: true, subtree: true });
})();
